export default "/institutions/sofi.svg";